
	import { Component, Vue } from 'vue-property-decorator';

	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import { CreateElement, VNode } from 'vue';
	import { serverProps } from '@/Common/Environment/const';
	import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';

	@Component({})
	export default class NavBar extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			const style: Partial<CSSStyleDeclaration> = {};

			!this.isShowNavigationBar && (style.display = 'none');
			!this.isXSClientType && (style.minWidth = '1140px');

			return style;
		}

		protected mounted(): void {
			this.$nextTick(() => {
				this.renderWorkspaceSwitch();
			});
		}

		protected renderWorkspaceSwitch(): void {
			const el = this.$refs.root as HTMLElement;
			if (this.isNewExperienceEnabled && el) {
				new Vue({
					el,
					render: (h: CreateElement): VNode => {
						return h('WorkspaceSwitch', {
							props: {
								value: this.checkedWorkspaceSwitch,
								disabled: this.disabledWorkspaceSwitch
							},
							on: {
								input: (value: boolean): void => {
									this.checkedWorkspaceSwitch = value;
								}
							}
						});
					}
				});
			}
		}

		protected get isNewExperienceEnabled(): boolean {
			return this.state.isNewExperienceEnabled;
		}

		protected get error404(): boolean {
			return !!this.state.error404;
		}

		protected get helpMenu(): APS.IMenuItems | null {
			return this.state.helpMenu;
		}

		protected get userMenu(): APS.IMenuItems | null {
			return this.state.userMenu;
		}

		protected get expertModeMenu(): APS.IMenuItem | null {
			return this.state.expertModeMenu;
		}

		protected get isShowNavigationBar(): boolean {
			return this.state.isShowNavigationBar;
		}

		protected get breadcrumbs(): APS.IBreadcrumbs {
			return this.state.breadcrumbs;
		}

		protected get isShowUserMenu(): boolean {
			return this.state.isShowUserMenu;
		}

		protected get isShowNotifications(): boolean {
			return this.state.isShowNotifications;
		}

		protected get userDisplayName(): string {
			return this.state.userDisplayName;
		}

		protected get isHelpMenuVisible(): boolean {
			return this.state.isHelpMenuVisible;
		}

		protected get isXSClientType(): boolean {
			return this.state.isXSClientType;
		}

		protected get contextPath(): string {
			return this.state.contextPath;
		}

		protected get isMDClientType(): boolean {
			return this.state.isMDClientType;
		}

		protected get viewParams(): APS.IViewParams {
			return this.state.viewParams;
		}

		protected get isHelpCenterEnabled(): boolean {
			return helpCenterServiceModule.isEnabled || false;
		}

		protected get isHelpCenterOpened(): boolean {
			return helpCenterServiceModule.isHelpCenterOpened || false;
		}

		protected get hideNotifyControl(): boolean {
			//hardcode condition moved from old index.jsp
			return !!(
				this.viewParams.viewId &&
				this.viewParams.viewId === 'http://www.parallels.com/ccp-activation#activation-wizard'
			);
		}

		protected get checkedWorkspaceSwitch(): boolean {
			return !!aps.navigation.vueWorkspace;
		}

		protected set checkedWorkspaceSwitch(value: boolean) {
			aps.navigation.enableWorkspace(value);
		}

		protected get disabledWorkspaceSwitch(): boolean {
			return aps.navigation.loadingUpdateNewExperience;
		}

		protected openHelpCenterHandler(): void {
			if (!this.isHelpCenterEnabled) {
				return;
			}
			helpCenterServiceModule.setIsHelpCenterOpened(!helpCenterServiceModule.isHelpCenterOpened);
		}

		protected notificationClickedHandler(): void {
			if (!this.isHelpCenterEnabled) {
				return;
			}
			helpCenterServiceModule.setIsHelpCenterOpened(false);
		}

		protected timeoutId: NodeJS.Timeout | undefined = undefined;
	}
